import {searchBarActions} from '../actions/searchBarActions'

const initialState = {
    filters: [],
    searchQuery:'',
    currentOpen:"",
    tags: []
};


export const reducer = (state = initialState,action)=>{
    switch(action.type){
        case searchBarActions.addFilter:
            return{
                ...state,
                filters:[...state.filters,action.payload]
            }
           //break;
        case searchBarActions.removeFilter:
            return{
                ...state,
                filters:state.filters.filter(e=>e!==action.payload)
            }
            //break;
        case searchBarActions.removeAll:
            return{
                ...state,
                filters:action.payload.filters,
                searchQuery: action.payload.searchQuery
            }
        case searchBarActions.addSearchQuery:
            return{
                ...state,
                searchQuery: action.payload
            }
            //break;
        case searchBarActions.removeSearchQuery:
            return{
                ...state,
                searchQuery: action.payload
            }   
            //break; 
        case searchBarActions.currentOpen:
            return{
                ...state,
                currentOpen:action.payload
            }
            //break;
        default:
            return state;
            //break;
    }
}